import React from "react";
import { Box, Slider, Typography } from "@mui/material";

const RoundingField = ({ value, onChange }) => (
  <Box data-testid="rounding-field">
    <Typography sx={{ fontSize: 13, color: "#565556", fontFamily: "DM Sans" }}>
      Corner rounding: {value ?? 8}px
    </Typography>
    <Slider
      value={typeof value === "number" ? value : 8}
      min={0}
      max={40}
      step={1}
      onChange={(_, v) => onChange(v)}
      sx={{ maxWidth: 240, color: "#9B5AF8" }}
    />
  </Box>
);

export default RoundingField;
